import { render, staticRenderFns } from "./BCNetworkConfigurationSettings.vue?vue&type=template&id=1cdc04aa&scoped=true"
import script from "./BCNetworkConfigurationSettings.vue?vue&type=script&lang=js"
export * from "./BCNetworkConfigurationSettings.vue?vue&type=script&lang=js"
import style0 from "./BCNetworkConfigurationSettings.vue?vue&type=style&index=0&id=1cdc04aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdc04aa",
  null
  
)

export default component.exports